module.exports = __webpack_public_path__ + "static/media/application_manager.6a7499c1.svg";